export default "__VITE_ASSET__EkxOFkRN__"